import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Star, Users } from 'lucide-react';
export function SocialProofSection() {
  const testimonials = [{
    name: 'Carlos M.',
    role: 'Estudiante Universitario',
    text: 'Antes pasaba horas leyendo y al día siguiente no recordaba nada. Con el Método M3, mis tiempos de estudio se redujeron a la mitad y mis notas subieron.',
    avatar: 'C'
  }, {
    name: 'Laura G.',
    role: 'Profesional',
    text: 'Increíble cómo algo tan simple puede cambiar tu forma de procesar información. El palacio de la memoria es una técnica que uso todos los días en mi trabajo.',
    avatar: 'L'
  }, {
    name: 'Andrés V.',
    role: 'Opositor',
    text: 'Estudiar para oposiciones era un infierno hasta que descubrí este ebook. La asociación visual me ha salvado la vida para memorizar leyes complejas.',
    avatar: 'A'
  }];
  return <section className="py-24 relative bg-slate-900/50" data-id="element-121">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center justify-center mb-16 text-center" data-id="element-123">
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-cerebro-blue/10 border border-cerebro-blue/20 text-cerebro-blue mb-8" data-id="element-124">
            <Users className="w-5 h-5" data-id="element-125" />
            <span className="font-semibold tracking-wide" data-id="element-126">
              Más de 1,000 personas mejorando su memoria
            </span>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-127">
          {testimonials.map((test, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="glass-card p-8 flex flex-col" data-id="element-128">
              <div className="flex gap-1 mb-6" data-id="element-129">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-130" />)}
              </div>
              <p className="text-slate-300 text-lg mb-8 flex-grow italic" data-id="element-131">
                "{test.text}"
              </p>
              <div className="flex items-center gap-4" data-id="element-132">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-cerebro-blue to-cyan-400 flex items-center justify-center text-white font-bold text-xl" data-id="element-133">
                  {test.avatar}
                </div>
                <div data-id="element-134">
                  <h4 className="text-white font-bold" data-id="element-135">{test.name}</h4>
                  <p className="text-slate-400 text-sm" data-id="element-136">{test.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}